<template>
	<div class="masonry">
		<div v-if="$path(content, 'heading')" class="masonry__heading" v-html="content.heading"></div>
		<div class="masonry__items container">
			<div v-for="(item, index) in content.gallery" :key="index">
				<div class="masonry__item ">
					<img
						:src="item.url"
						:alt="item.url"
						ref="items"
						:style="{ objectPosition: `${item.focalPoint.x * 100}% ${item.focalPoint.y * 100}%` }"
					/>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import MediumZoom from 'medium-zoom'
export default {
	props: {
		content: {
			type: Object,
			default: () => [],
		},
	},
	data() {
		return {
			zoomer: MediumZoom([], {
				scrollOffset: 20,
				background: 'rgba(0, 0, 0, .6)',
			}),
		}
	},
	watch: {
		content: {
			handler: 'attach',
			immediate: true,
		},
	},
	methods: {
		attach() {
			this.detach()
			this.$nextTick(() => this.zoomer.attach(this.$refs.items))
		},
		detach() {
			if (!this.zoomer) return
			this.zoomer.detach()
		},
	},
	beforeDestroy() {
		this.detach()
	},
}
</script>

<style lang="scss">
@import '@/styles/base/_variables.scss';
@import '@/styles/utils/_mixins.scss';

.masonry {
	padding: 3rem 0;
	$gap: 0.5rem;

	&__heading {
		max-width: 550px;
		width: 100%;
		margin: 0 auto 5rem;
		text-align: center;
	}
	&__items {
		column-count: 4;
		column-gap: $gap;

		@include respond-below('phone') {
			column-count: 2;
			padding: 0 0.5rem !important;
		}
	}
	&__item {
		padding-bottom: $gap;
	}
}
img {
	max-width: 100%;
	width: 100%;
	display: block;
}
</style>
